import { render, staticRenderFns } from "./importform-new-1.vue?vue&type=template&id=5e80ff5e&scoped=true&"
import script from "./importform-new-1.vue?vue&type=script&lang=js&"
export * from "./importform-new-1.vue?vue&type=script&lang=js&"
import style0 from "./importform-new-1.vue?vue&type=style&index=0&id=5e80ff5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e80ff5e",
  null
  
)

export default component.exports